import http, { apiErrorMessage, descargarExcelPorToken } from '../../http';

const vRutaDashboard = 'dashboard/';

export const getFechaLarga = () =>{
    return (dispatch,getState) =>{
        http.get(vRutaDashboard + 'fecha-actual')
            .then(function(response){
                // Envelope v1: {data:{Fecha}}
                dispatch({
                    type: "DASHBOARD_FECHA_SUCCESS", payload:{
                        data: response.data.data
                    }
                })
            }).catch(function (error) {
                dispatch({ type: 'DASHBOARD_FECHA_ERROR', payload: { error: apiErrorMessage(error) } });
            }).finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            }
        );
    }
}

export const getListForTable = (sucursal) =>{
    return (dispatch, getState) => {
        http.get(vRutaDashboard + 'resumen-repartos', { params: { sucursal } })
            .then(function (response){
                // Envelope v1: {data:{Tabla,Repartos}}
                dispatch({
                    type: "DASHBOARD_SUCCESS", payload: {
                        data: response.data.data,
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'DASHBOARD_ERROR', payload: { error: apiErrorMessage(error) } });
            })
            .finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            }
        );
    }
}

export const getIndicadores = (sucursal) => {
    return (dispatch, getState) => {
        http.get(vRutaDashboard + 'efectividad-ead', { params: { sucursal } })
            .then(function (response){
                // Envelope v1: {data:{ead,rad}}
                dispatch({
                    type: "DASHBOARD_INDICADORES_SUCCESS", payload: {
                        data: response.data.data,
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'DASHBOARD_ERROR', payload: { error: apiErrorMessage(error) } });
            })
            .finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            }
        );
    }
}

// Efectividad por sucursal de un dia del historial (fecha vacia = ultimo dia calculado).
// Envelope v1: {data:{fecha,fechas,global,sucursales}}
export const getEfectividadSucursales = (fecha) => {
    return (dispatch) => {
        const params = fecha ? { fecha } : {};
        http.get(vRutaDashboard + 'efectividad-sucursales', { params })
            .then(function (response) {
                dispatch({ type: "DASHBOARD_EFECTIVIDAD_SUCURSALES_SUCCESS", payload: { data: response.data.data } });
            })
            .catch(function (error) {
                dispatch({ type: 'DASHBOARD_EFECTIVIDAD_ERROR', payload: { error: apiErrorMessage(error) } });
            });
    }
}

// Evolucion por dia (ultimos N dias del historial). sucursal 1 = global ponderado.
// Envelope v1: {data:{sucursal,dias,filas}}
export const getEfectividadHistorial = (sucursal, dias) => {
    return (dispatch) => {
        http.get(vRutaDashboard + 'efectividad-historial', { params: { sucursal, dias: dias || 30 } })
            .then(function (response) {
                dispatch({ type: "DASHBOARD_EFECTIVIDAD_HISTORIAL_SUCCESS", payload: { data: response.data.data } });
            })
            .catch(function (error) {
                dispatch({ type: 'DASHBOARD_EFECTIVIDAD_ERROR', payload: { error: apiErrorMessage(error) } });
            });
    }
}

// Excel de entregas/devoluciones diarias por unidad (ultimos 30 dias): flujo de 2 pasos
// autenticado en una sola accion — POST genera el .xlsx y devuelve {nombreexcel,fileToken};
// luego se descarga por token (blob + <a download>). sucursal 1 (matriz) => todas.
// Devuelve la promesa para que la vista controle el estado de "descargando".
export const descargarEntregasDiarias = (sucursal) => {
    return (dispatch) => {
        return http.post(vRutaDashboard + 'entregas-diarias/excel', { sucursal })
            .then(function (response) {
                // Envelope v1: {data:{nombreexcel,fileToken}}
                const excel = response.data.data;
                return descargarExcelPorToken('dashboard/entregas-diarias', excel.fileToken, excel.nombreexcel);
            })
            .catch(function (error) {
                dispatch({ type: 'DASHBOARD_ENTREGAS_EXCEL_ERROR', payload: { error: apiErrorMessage(error) } });
                return Promise.reject(error);
            });
    }
}

export const LimpiarEntregasDiariasError = () => {
    return (dispatch) => {
        dispatch({ type: 'DASHBOARD_ENTREGAS_EXCEL_LIMPIAR' });
    }
}
